import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary } from '../../../../web/styles/colors';
import { absoluteCenterStyle } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	anchorStyles: {
		maxWidth: 349,
		margin: '0 auto',
	},
	autocompleteBox: {
		textAlign: 'left',
		width: '100%',
	},
	container: {
		'@media only screen and (max-height: 768px)': {
			padding: 20,
		},
		alignItems: 'flex-start',
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		overflowY: 'auto',
		padding: '30px 0',
	},
	dropdownClassName: {
		width: 350,
	},
	iconSpan: {
		marginRight: 8,
		marginTop: 4,
	},
	loadingTagsPlaceholder: {
		...absoluteCenterStyle,
	},
	searchBox: {
		backgroundColor: '#f9f9f9',
		border: '1px solid #f2f2f2',
		borderRadius: 3,
		color: '#4a4a4a',
		display: 'inline-block',
		fontSize: 14,
		outline: 'none',
		padding: 12,
		verticalAlign: 'middle',
		width: '100%',
	},
	sectionIcon: {
		marginRight: 8,
		height: 16,
		width: 16,
	},
	createTag: {
		display: 'block',
		padding: 10,
		fontSize: 14,
	},
	noMargin: {
		margin: 0,
	},
	sectionWrap: {
		borderBox: 'box-sizing',
		alignItems: 'center',
		display: 'flex',
		padding: 10,
		borderTop: `1px solid ${borderColor}`,
		borderBottom: `1px solid ${borderColor}`,
	},
	sectionTitle: {
		color: brandPrimary,
		fontSize: 14,
		margin: 0,
	},
});
